<template>
    <div class="layout__padding-clear">
        <div class="layout__position-center text__align-center layout__padding__top-25px" id="welcome">
            <div class="text__colour-teal text__style-bold text__align-center layout__margin__bottom-25px text__size-22">Welcome to Ravensworth's<br>Instant Print/Marketing App</div>

            <div class="text__colour-teal text__size-15 text__style-bold text__align-center layout__margin__bottom-10">We'll now need to on-board you,</div>
            <div class="text__colour-teal text__size-15 text__style-bold text__align-center layout__margin__bottom-20">please note this will only need to be done once</div>

            <div class="text__align-center">
                <el-button id="accountOptionsDialog" class="button__base button__background-red text__align-center layout__cursor-pointer layout__margin__bottom-20 layout__width-400px text__line-height-13 text__size-16-important"
                        v-on:click="createAccount('ACCOUNT', 'MONTHLYEMAILINVOICE')">Register for a <br><b>Credit account</b><br>Payment via monthly invoice</el-button>
            </div>

            <div class="text__align-center">
                <el-button id="accountOptionsDialog" class="button__base button__background-red text__align-center layout__cursor-pointer layout__margin__bottom-40 layout__width-400px text__line-height-13 text__size-16-important"
                        v-on:click="createAccount('PAYG', 'PAYGEMAILINVOICE')">Register for a <br><b>PAYG account</b><br>Payment via credit or debit card</el-button>
            </div>
        </div>

        <div class="layout__padding-25px layout__width-1100px hidden" id="accountForm">
            <h2 class="text__colour-teal text__align-center layout__margin__bottom-20">Create a {{title}} account</h2>

            <h3 class="text__colour-teal text__align-center layout__margin__bottom-20">
                To create your account, please fill in the additional information
            </h3>

            <div class="layout__padding__top-25px text__size-14">
                <el-form :model="accountForm" status-icon :rules="rules" ref="accountForm">
                    <el-row class="layout__padding-0-50px">
                        <el-col :span="5">
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px" v-show="false">Account Type</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Company Name*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Branch Name*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Brand Name</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Delivery Address 1*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Delivery Address 2</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Delivery Address 3</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Town*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">County*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Postcode*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Payment</div>

                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Email / Username*</div>
                                <!--<div class="text__colour-teal layout__padding-5-0 layout__height-45px">Password*</div>-->

                                <!--<div class="text__colour-teal layout__padding-5-0 layout__height-45px layout__width-400px layout__break-word">
                                    Keep me informed of exclusive news and offers
                                </div>-->
                        </el-col>

                        <el-col :span="7">
                            <el-form-item prop="account_type" v-show="false">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Account Type"
                                            v-model="accountForm.account_type" readonly></el-input>
                            </el-form-item>

                            <el-form-item prop="company_name">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Company Name"
                                            v-model="accountForm.company_name" clearable autofocus></el-input>
                            </el-form-item>

                            <el-form-item prop="branch_name">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Branch Name"
                                            v-model="accountForm.branch_name" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="brand_name">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Brand Name"
                                            v-model="accountForm.brand_name" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="branch_address1">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Delivery Address 1"
                                            v-model="accountForm.branch_address1" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="branch_address2">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Delivery Address 2"
                                            v-model="accountForm.branch_address2" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="branch_address3">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Delivery Address 3"
                                            v-model="accountForm.branch_address3" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="branch_town">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Town"
                                            v-model="accountForm.branch_town" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="branch_county">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="County"
                                            v-model="accountForm.branch_county" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="branch_postcode">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Postcode"
                                            v-model="accountForm.branch_postcode" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="payment_method_display">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Payment"
                                            v-model="payment_method_display" readonly></el-input>
                            </el-form-item>

                            <el-form-item prop="email">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Email"
                                            v-model="accountForm.email" clearable></el-input>
                            </el-form-item>

                            <!--<el-form-item prop="password">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Password"
                                            v-model="accountForm.password" v></el-input>
                            </el-form-item>-->

                            <!--<el-form-item class="layout__position-right layout__width-75px">
                                <el-checkbox class="consent-checkbox layout__border__bottom-none text__direction-left-to-right" v-model="accountForm.marketingEmailsConsent"></el-checkbox>
                            </el-form-item>-->
                        </el-col>

                        <el-col :span="5">
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Main Contact First Name*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Main Contact Surname*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Main Contact Telephone*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Main Contact Email*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Accounts Contact*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Accounts Contact Telephone*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Invoice Email Address*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Invoice Address 1<div class="text__colour-black text__size-12 font-10-required">(if different from delivery address)</div></div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Invoice Address 2</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Invoice Address 3</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Town</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">County</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-45px">Postcode</div>
                        </el-col>

                        <el-col :span="7">
                            <el-form-item prop="main_contact_firstname">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Main Contact First Name"
                                            v-model="accountForm.main_contact_firstname" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="main_contact_surname">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Main Contact Surname"
                                            v-model="accountForm.main_contact_surname" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="main_contact_telephone">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Main Contact Telephone"
                                            v-model="accountForm.main_contact_telephone" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="main_contact_email">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Main Contact Email"
                                            v-model="accountForm.main_contact_email" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="accounts_contact_name">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Accounts Contact"
                                            v-model="accountForm.accounts_contact_name" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="accounts_contact_telephone">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Accounts Contact Telephone"
                                            v-model="accountForm.accounts_contact_telephone" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="accounts_contact_email">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Invoice Email Address"
                                            v-model="accountForm.accounts_contact_email" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="billing_address1">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Invoice Address 1"
                                            v-model="accountForm.billing_address1" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="billing_address2">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Invoice Address 2"
                                            v-model="accountForm.billing_address2" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="billing_address3">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Invoice Address 3"
                                            v-model="accountForm.billing_address3" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="billing_town">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Town"
                                            v-model="accountForm.billing_town" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="billing_county">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="County"
                                            v-model="accountForm.billing_county" clearable></el-input>
                            </el-form-item>

                            <el-form-item prop="billing_postcode">
                                <el-input class="el-input-credit-account layout__width-250px" placeholder="Postcode"
                                            v-model="accountForm.billing_postcode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row class="layout__padding-0-50px" v-show="showRecaptcha === false">
                        <div class="text__align-center">
                            <div class="layout__position-center layout__display-inline-block">
                                <el-form-item>
                                    <el-checkbox class="layout__border__bottom-none text__direction-left-to-right" v-model="accountForm.marketingEmailsConsent">
                                        <div class="layout__padding__left-20px font-12-required">Keep me informed of exclusive news and offers</div>
                                    </el-checkbox>
                                </el-form-item>
                            </div>
                        </div>
                    </el-row>

                    <el-row class="layout__padding-0-50px" v-show="showRecaptcha === true">
                        <div class="layout__padding-20-0">
                            <div class="layout__position-left layout__display-inline-block">
                                <el-form-item>
                                    <el-checkbox class="layout__border__bottom-none text__direction-left-to-right" v-model="accountForm.marketingEmailsConsent">
                                        <div class="layout__padding__left-20px font-12-required">Keep me informed of exclusive news and offers</div>
                                    </el-checkbox>
                                </el-form-item>
                            </div>

                            <div class="layout__position-right layout__display-inline-block layout__width-50">
                                <vue-recaptcha
                                        ref="recaptcha"
                                        @verify="onVerify"
                                        @expired="onExpired"
                                        :loadRecaptchaScript="true"
                                        :sitekey="'6Lfg2qIUAAAAADKlBXuXz-tPxFAheAyPTQoevfUk'">
                                </vue-recaptcha>
                            </div>
                        </div>
                    </el-row>

                    <!--<div class="layout__padding-clear" v-show="showRecaptcha === true">
                        <vue-recaptcha
                                ref="recaptcha"
                                class="layout__padding-20-0"
                                @verify="onVerify"
                                @expired="onExpired"
                                :sitekey="'6Lfg2qIUAAAAADKlBXuXz-tPxFAheAyPTQoevfUk'">
                        </vue-recaptcha>
                    </div>-->
                    
                    <div class="layout__padding-clear layout__position-center text__align-center layout__padding__top-20px layout__break-word">
                        If you would like a hand filling in this form, give Ravensworth Customer Services a call on t:01865 712211.
                    </div>

                    <div class="layout__padding-clear layout__padding__top-20px">
                        <div class="layout__padding-clear">
                            <!--<el-button class="button-red button__base layout__position-center layout__width-200px"
                                        :disabled="formInvalid"
                                        v-on:click="validateForm()">Confirm
                            </el-button>-->
                            <el-button class="button-red button__base layout__position-center layout__width-200px"
                                        :disabled="recaptchaNotComplete"
                                        v-on:click="validateForm()">Register
                            </el-button>
                        </div>
                    </div>

                    <div class="layout__padding-clear layout__position-center text__align-center layout__padding__top-20px layout__break-word" v-show="account_type == 'PAYG'">
                        By signing up you agree to our <a class="link__colour-teal" href="https://ravensworth.co.uk/terms-and-conditions/" target="new">Terms and Conditions</a> and <a class="link__colour-teal" href="https://ravensworth.co.uk/privacy-policy/" target="new">Privacy Policy</a>
                        <br />
                        You are agreeing to pay for orders using a credit or debit card. If you would like to set up a credit account and be billed monthly please use the Credit Account option.
                    </div>

                    <div class="layout__padding-clear layout__position-center text__align-center layout__padding__top-20px layout__break-word" v-show="account_type == 'ACCOUNT'">
                        By signing up you agree to our <a class="link__colour-teal" href="https://ravensworth.co.uk/terms-and-conditions/" target="new">Terms and Conditions</a> and <a class="link__colour-teal" href="https://ravensworth.co.uk/privacy-policy/" target="new">Privacy Policy</a>
                        <br />
                        *Subject to standard credit checks, credit accounts can take up to 48 hours to set up. You will be notified on email once we have finished setting up your account.
                    </div>

                    <!--<div class="layout__padding-clear layout__padding__top-20px" v-show="accountForm.account_type == 'PAYG'">
                        <div class="text__size-10 layout__position-center layout__width-370px">
                            <div>By signing up you will be able to pay for orders using a credit or debit card</div>
                            <div>If you would like to set up a credit account* and be billed monthly please email
                                <br><a
                                        href="mailto:customer.services@ravensworth.co.uk" class="link__colour-teal"
                                        target="_top">client.support@ravensworth.co.uk</a></div>
                            By signing up you agree to our <a href="https://ravensworth.co.uk/terms-and-conditions/"
                                                                class="link__colour-teal" target="_top">Terms and
                            Conditions</a> and <a
                                href="https://ravensworth.co.uk/privacy-policy/" class="link__colour-teal"
                                target="_top">Privacy
                            Policy</a>
                            <div>*Subject to standard credit checks, credit accounts can take up to 48 hours to set up.</div>
                            <div>This option will automatically appear in your checkout options once approved.</div>
                        </div>
                    </div>-->
                </el-form>
            </div>
        </div>

        <div class="layout__position-center text__align-center layout__padding__top-25px hidden" id="credit_message">
            <h2 class="text__colour-teal layout__margin__bottom-20">Thank you!</h2>

            <div>
                <p class="layout__margin__bottom-20">Your request has gone to our accounts team<br>to review, please note credit checks will be<br>performed.</p>
                <p class="layout__margin__bottom-20">If we need any additional information we'll be<br>in touch. Otherwise you'll receive an email once<br>your account has been upgraded, this could take<br>up to 48 hours.</p>
                <p class="layout__margin__bottom-20">Can't wait?<br>Speak to our Customer Service team now<br>t: 01865 712211<br>e: orders@printconcern.co.uk</p>
            </div>
        </div>

        <div class="layout__position-center text__align-center layout__padding__top-25px hidden" id="payg_message">
            <h2 class="text__colour-teal layout__margin__bottom-20">Thank you!</h2>

            <div>
                <p class="layout__margin__bottom-20">You'll receive a confirmation email with your<br>login details within the next few minutes.</p>
                <p class="layout__margin__bottom-20">If you don't receive an email please check your<br>Spam folder just in case the confirmation email<br>got delivered there instead of your inbox</p>
                <p class="layout__margin__bottom-20">If you need to speak to our Customer Service team,<br>please use the contact details below:</p>
                <p class="layout__margin__bottom-20">t: 01865 712211<br>e: orders@printconcern.co.uk</p>
            </div>
        </div>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </div>
</template>
<script>
    import Axios from 'axios';
    import {Loading} from 'element-ui';
    import {axios} from '@/mixins/Axios.js';
    import Router from '../../router';
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        name: "createaccount",
        props: {},
        mixins: [axios],
        computed: {
            title: function() {
                if (this.accountForm.account_type == 'ACCOUNT') {
                    return 'Credit';
                } else {
                    return 'Pay As You Go';
                }
            },
            payment_method_display: function() {
                if (this.payment_method == 'PAYGEMAILINVOICE') {
                    return 'PAYG email invoice';
                } else { //MONTHLYEMAILINVOICE
                    return 'Monthly email invoice';
                }
            },
            account_type: function() {
                return this.accountForm.account_type;
            }
        },
        components: {
            VueRecaptcha
        },
        data() {
            return {
                loading: false,
                processing: false,
                partnerRef: '',
                partnerCustomerKey: 0,
                email: '',
                createAccountDialog: false,
                createPAYGDialog: false,
                processing: false,
                createCreditAccount: true,
                createCreditRequestSent: false,
                createPAYGRequestSent: false,
                recaptchaNotComplete: true,
                showRecaptcha: true,
                accountForm: {
                    account_type: '',
                    company_name: '',
                    branch_name: '',
                    brand_name: '',
                    branch_address1: '',
                    branch_address2: '',
                    branch_address3: '',
                    branch_town: '',
                    branch_county: '',
                    branch_postcode: '',
                    payment_method: '',
                    marketingEmailsConsent: false,
                    main_contact_firstname: '',
                    main_contact_surname: '',
                    main_contact_telephone: '',
                    main_contact_email: '',
                    accounts_contact_name: '',
                    accounts_contact_telephone: '',
                    accounts_contact_email: '',
                    billing_address1: '',
                    billing_address2: '',
                    billing_address3: '',
                    billing_town: '',
                    billing_county: '',
                    billing_postcode: '',
                    email: '',
                    //password: '',
                },
                rules: {
                    company_name: [
                        {required: true, message: 'Company Name required', trigger: 'blur'}
                    ],
                    branch_name: [
                        {required: true, message: 'Branch Name required', trigger: 'blur'}
                    ],
                    branch_address1: [
                        {required: true, message: 'Branch Address Line 1 required', trigger: 'blur'}
                    ],
                    branch_town: [
                        {required: true, message: 'Branch Town required', trigger: 'blur'}
                    ],
                    branch_county: [
                        {required: true, message: 'Branch County required', trigger: 'blur'}
                    ],
                    branch_postcode: [
                        {required: true, message: 'Branch Postcode required', trigger: 'blur'}
                    ],
                    main_contact_firstname: [
                        {required: true, message: 'Main Contact First Name required', trigger: 'blur'}
                    ],
                    main_contact_surname: [
                        {required: true, message: 'Main Contact Surname required', trigger: 'blur'}
                    ],
                    main_contact_telephone: [
                        {required: true, message: 'Main Contact Telephone required', trigger: 'blur'}
                    ],
                    main_contact_email: [
                        {required: true, message: 'Main Contact Email required', trigger: 'blur'},
                        {
                            required: true,
                            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            message: 'Main Contact Email invalid',
                            trigger: 'blur'
                        }
                    ],
                    accounts_contact_name: [
                        {required: true, message: 'Accounts Contact Surname required', trigger: 'blur'}
                    ],
                    accounts_contact_telephone: [
                        {required: true, message: 'Accounts Contact Telephone required', trigger: 'blur'}
                    ],
                    accounts_contact_email: [
                        {required: true, message: 'Account Email required', trigger: 'blur'},
                        {
                            required: true,
                            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            message: 'Invoice Email Address invalid',
                            trigger: 'blur'
                        }
                    ],
                    /*billing_address1: [
                        {required: true, message: 'Billing Address Line 1 required', trigger: 'blur'}
                    ],
                    billing_town: [
                        {required: true, message: 'Billing Town required', trigger: 'blur'}
                    ],
                    billing_county: [
                        {required: true, message: 'Billing County required', trigger: 'blur'}
                    ],
                    billing_postcode: [
                        {required: true, message: 'Billing Postcode required', trigger: 'blur'}
                    ],*/
                    email: [
                        {required: true, message: 'Email / Username required', trigger: 'blur'}
                    ],
                    /*password: [
                        {required: this.accountForm.account_type == 'PAYG', message: 'Password required', trigger: 'blur'},
                        {
                            required: this.accountForm.account_type == 'PAYG',
                            min: 8,
                            message: 'Password must be 8 characters or more',
                            trigger: 'blur'
                        }
                    ],*/
                },
            }
        },
        beforeUpdate() {
        },
        created() {
            this.accountForm.company_name = '';
            this.accountForm.brand_name = '';
            this.accountForm.branch_name = '';
            this.accountForm.branch_telephone = '';
            this.accountForm.branch_email = '';
            this.accountForm.branch_address1 = '';
            this.accountForm.branch_address2 = '';
            this.accountForm.branch_address3 = '';
            this.accountForm.branch_town = '';
            this.accountForm.branch_county = '';
            this.accountForm.branch_postcode = '';
            this.accountForm.decision_maker_firstname = '';
            this.accountForm.decision_maker_surname = '';
            this.accountForm.decision_maker_telephone = '';
            this.accountForm.decision_maker_email = '';
            this.accountForm.account_email = '';
            this.accountForm.invoice_name_and_address = '';

            if (this.$route.query.partnerRef !== undefined) {
                this.partnerRef = this.$route.query.partnerRef;
            }

            if (this.$route.query.email !== undefined) {
                this.accountForm.main_contact_email = this.$route.query.email;
            }

            if (this.$route.query.PartnerCustomerKey !== undefined) {
                this.partnerCustomerKey = this.$route.query.PartnerCustomerKey;
            }
        },
        mounted() {
            if (`${process.env.VUE_APP_ENVIRONMENT}` === 'dev' || `${process.env.VUE_APP_ENVIRONMENT}` === 'qa') {
                this.showRecaptcha = false;
                this.recaptchaNotComplete = false;
            }
        },
        methods: {
            continueToAccountForm() {
                document.getElementById("welcome").classList.add("hidden");
                document.getElementById("accountForm").classList.remove("hidden");
            },
            validateForm() {
                if (this.processing === true) {
                    return;
                }

                this.$refs['accountForm'].validate((valid) => {

                    console.log('vaild=' + valid);

                    if (valid) {
                       this.processing = true;
                       this.loading = true;

                        let updatedValues = {
                            'abpUserId': null, // int64 populated by backend
                            'tenantId': null,  // int populated by backend
                            'partnerRef': this.partnerRef,
                            'partnerCustomerKey': this.partnerCustomerKey,
                            'companyName': this.accountForm.company_name,
                            'brandName': this.accountForm.brand_name,
                            'branchName': this.accountForm.branch_name,
                            'branchTelephone': null,
                            'branchEmail': null,
                            'branchAddressLine1': this.accountForm.branch_address1,
                            'branchAddressLine2': this.accountForm.branch_address2,
                            'branchAddressLine3': this.accountForm.branch_address3,
                            'branchTown': this.accountForm.branch_town,
                            'branchCounty': this.accountForm.branch_county,
                            'branchPostcode': this.accountForm.branch_postcode,
                            'mainContactFirstName': this.accountForm.main_contact_firstname,
                            'mainContactLastName': this.accountForm.main_contact_surname,
                            'mainContactTelephone': this.accountForm.main_contact_telephone,
                            'mainContactEmail': this.accountForm.main_contact_email,
                            'accountsContactName': this.accountForm.accounts_contact_name,
                            'accountsContactTelephone': this.accountForm.accounts_contact_telephone,
                            'accountsEmail': this.accountForm.accounts_contact_email,
                            'billingAddressLine1': this.accountForm.billing_address1,
                            'billingAddressLine2': this.accountForm.billing_address2,
                            'billingAddressLine3': this.accountForm.billing_address3,
                            'billingTown': this.accountForm.billing_town,
                            'billingCounty': this.accountForm.billing_county,
                            'billingPostcode': this.accountForm.billing_postcode,
                            'marketingEmailsConsent': this.accountForm.marketingEmailsConsent,
                            'RegistrantUserEmail': this.accountForm.email,
                            'accountType': this.accountForm.account_type, // Expected values:  PAYG or ACCOUNT
                            'paymentMethod': this.accountForm.payment_method // Expected values: PAYGEMAILINVOICE or MONTHLYEMAILINVOICE
                        }

                        console.log(JSON.stringify(updatedValues));

                        var endpoint = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/api/services/app/Customer/SubmitPartnerCustomerAccountApplication`;
                        Axios.post(endpoint, updatedValues, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log(response.data);

                                document.getElementById("accountForm").classList.add("hidden");

                                if (this.accountForm.account_type == 'ACCOUNT') {
                                    document.getElementById("credit_message").classList.remove("hidden");
                                } else {
                                    document.getElementById("payg_message").classList.remove("hidden");
                                }

                                this.loading = false;
                                this.processing = false;
                            })
                            .catch(error => {
                                event.stopPropagation();
                                console.log(error);

                                this.loading = false;
                                this.processing = false;
                            })
                    }
                })
            },
            createAccount(accountType, paymentMethod) {
                console.log('createAccount - accountType=' + accountType + ', paymentMethod=' + paymentMethod);

                this.accountForm.account_type = accountType;
                this.accountForm.payment_method = paymentMethod;

                console.log('createAccount - partnerRef=' + this.partnerRef + ', email=' + this.email);

                document.getElementById("welcome").classList.add("hidden");
                document.getElementById("accountForm").classList.remove("hidden");
            },
            onSubmit: function () {
                this.$refs.invisibleRecaptcha.execute();
            },
            onVerify: function (response) {
                console.log('Verify: ' + response);
                this.recaptchaNotComplete = false;
            },
            onExpired: function () {
                console.log('Expired');
            },
            resetRecaptcha() {
                this.$refs.recaptcha.reset(); // Direct call reset method
            },
        },
    };
</script>
